import React from 'react';

const SMLoadingSpinner: React.FC = () => (
  <div className="sm-loading-page">
    <div className="sm-loading-card">
      <div className="sm-spinner" />
    </div>
  </div>
);

export default SMLoadingSpinner;
